import { NotFoundComponent } from './../shared/components/not-found/not-found.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { PermissionGuard } from '../guards/permission.guard';



export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../pages/oneof/modules/oneof.module').then(m => m.OneofModule)
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, PermissionGuard],
    loadChildren: () => import('../pages/admin/modules/admin.module').then(m => m.AdminModule)
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
